import React from "react";

/**
 * InProgress page component
 * Displays a message for features that are under development
 */
const InProgress = () => {
  return (
    <div className="flex h-full min-h-[70vh] flex-col items-center justify-center p-8">
      <div className="w-full max-w-lg rounded-xl bg-background-white p-8 text-center shadow-md">
        <h1 className="mb-4 text-2xl font-bold text-primary-700">
          Coming Soon
        </h1>

        <p className="mb-6 text-pretty text-foreground-muted">
          This feature is currently under development and will be available
          soon.
        </p>
      </div>
    </div>
  );
};

export default InProgress;
